import script from "./AListOfDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AListOfDetails.vue?vue&type=script&setup=true&lang=js"

import "./AListOfDetails.vue?vue&type=style&index=0&id=4b712404&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b712404"]])

export default __exports__